// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

//Import Magnificent Popup
//Import Magnificent Popup
import 'magnific-popup/dist/jquery.magnific-popup.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleGalleries from './routes/singleGalleries';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  singleGalleries,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js